
import { createApp } from "vue";
import "@/assets/scss/app.scss";

// Wrapper/queue para serializar llamadas a navigator.credentials.get (FedCM)
// Esto evita el error "Only one navigator.credentials.get request may be outstanding at one time."
// try {
//   if (typeof navigator !== 'undefined' && navigator.credentials && typeof navigator.credentials.get === 'function') {
//     const _origCredentialsGet = navigator.credentials.get.bind(navigator.credentials);
//     let _credLock = false;
//     const _credQueue = [];

//     navigator.credentials.get = function(options) {
//       return new Promise((resolve, reject) => {
//         const run = () => {
//           _credLock = true;
//           _origCredentialsGet(options)
//             .then((r) => resolve(r))
//             .catch((e) => reject(e))
//             .finally(() => {
//               _credLock = false;
//               const next = _credQueue.shift();
//               if (next) {
//                 // Ejecutar siguiente en la siguiente vuelta de evento
//                 setTimeout(() => {
//                   navigator.credentials.get(next.options).then(next.resolve).catch(next.reject);
//                 }, 0);
//               }
//             });
//         };

//         if (_credLock) {
//           _credQueue.push({ options, resolve, reject });
//         } else {
//           run();
//         }
//       });
//     };
//   }
// } catch (e) {
//   // No bloquear la inicialización de la app si algo falla aquí
//   console.warn('No se pudo envolver navigator.credentials.get:', e);
// }

import { createBootstrap } from "bootstrap-vue-next";
import pinia from '@/store';

import axios, {aplicarInterceptors} from "./libs/axios";
import router from '@/router';
import "./global-componenets";

import acl from  './libs/acl';

import element from './plugins/element';
import swal from './plugins/swal';

// import useDirectives from "./directives";


import fontIcon from './plugins/fontawesome';
import './libs/toastification';
import i18n, { loadLocaleAsync } from "./libs/i18n";

// vSelect
import vSelect from './plugins/vSelect';

// directives v-Mask
import VMask from "@ssibrahimbas/v-mask";


import App from './App.vue'

import Avatar from "@/components/avatar.vue";


// Laravel Echo
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost:import.meta.env.VITE_REVERB_HOST,
    wsPort:80,
    wssPort:import.meta.env.VITE_REVERB_WSS_PORT,
    forceTLS:true,
    enabledTransports: ['ws','wss'],
    disableStats:true,
    authorizer:(channel,options) => {
      return {
        authorize: (socketId,next) => {
          axios.post('/broadcasting/auth',{
            socket_id:socketId,
            channel_name:channel.name
          }).then(response => {
            next(null,response.data)
          }).catch(error => next(error))
        }
      }
    }
});

const app = createApp(App);


app.component('avatar',Avatar);
app.use(fontIcon);
app.use(acl);
app.use(pinia);
app.use(router);
app.use(element);
app.use(swal);
app.use(i18n);
app.use(vSelect);
app.use(VMask);
app.use(createBootstrap())
app.provide('i18n',i18n);
app.provide('loadLocaleAsync',loadLocaleAsync);

// Directives
// useDirectives(app);

app.mount('#app')

// Axios intercetors
aplicarInterceptors();
